module.exports = __webpack_public_path__ + "img/about-us.d30c2150.jpg";